import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} om {{waitingTime}} min.',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Levering',
    [ORDER_METHODS.PICKUP]: 'Afhentning',
    [ORDER_METHODS.ON_SITE]: 'Bordbestilling',
  },
};
